import { AppState } from '../reducers/root.reducer';
import { createSelector } from 'reselect';

const state = (state: AppState) => state.common.integration;

const getIntegration = createSelector(state, (state) => state);

const IntegrationSelector = { getIntegration };

export default IntegrationSelector;
